import { Text }     from '@chakra-ui/react';
import authStore    from '@/stores/authStore';
import { observer } from 'mobx-react';

const NavBarUserName = observer(() => {
	const currentUser = authStore.currentUser;
	return (
		<Text textWrap="nowrap" hideBelow="lg" color="white">{ currentUser.fullName }</Text>
	)
})

export default NavBarUserName;